import request from '@/utils/request.js'

//订单列表
export function orderList(page,pageSize,pay_status) {
    var params = {page:page,pageSize:pageSize};
    if(pay_status >-1){
        params.pay_status = pay_status;
    }
    return request({
        url: '/orders',
        method: 'GET',
        params:params
    })
}


//商品创建订单
export function createOrderByGoods(data) {
    return request({
        url:"/orders/goods",
        method:"POST",
        data
    })
}


/**
 * 订单详情
 * @param {订单id} id
 */
export function orderDetail(id){
    return request({
        url: '/orders/detail',
        method: 'GET',
        params:{id:id}
    })
}


//取消订单
export function cancelOrder(order_id) {
    return request({
        url: '/orders/cancel',
        method: 'PUT',
        params:{id:order_id}
    })
}




//课程添加到订单
export function addCourseOrder(good_id,blance,couponId) {
    var params = {g_id:good_id,g_type:1,balance_pay:blance * 100};
    if(couponId){
        params.c_id = couponId;
    }
    return request({
        url: '/orders/goods',
        method: 'POST',
        params:params
    })
}

//课程包添加到订单
export function addCoursePkgOrder(good_id,blance,couponId) {
    var params = {g_id:good_id,g_type:2,balance_pay:blance * 100};
    if(couponId){
        params.c_id = couponId;
    }
    return request({
        url: '/orders/goods',
        method: 'POST',
        params:params
    })
}

//购物车列表提交订单时可用的优惠券列表
export function cartCoupons(carts){
    return request({
        url: '/public/goods-list-coupons',
        method: 'POST',
        params:{goods:carts,page:1,pageSize:20}
    })
}

//微信支付订单
export function weiXinPay(order_no){
    return request({
        url:"/payment/wechatpay",
        method:'POST',
        params:{order_no:order_no,terminal_type:1}
    })
}
//支付宝支付
export function aliPay(order_no){
    return request({
        url:'/payment/alipay',
        method:'post',
        params:{order_no:order_no,terminal_type:1}
    })
}
//订单支付状态
export function orderPayState(order_no){
    return request({
        url:'/orders/status',
        method:'GET',
        params:{order_no:order_no}
    })
}
